<template>
  <div>
    <van-swipe :autoplay="3000" v-if="imgArr.length>0">
      <van-swipe-item v-for="(image, index) in imgArr" :key="index">
        <img :src="image" />
      </van-swipe-item>
    </van-swipe>
    <van-grid :border="false" :column-num="1" class="index_banner" v-else>
      <van-grid-item>
        <van-image width="100%" :src="require('../../assets/Image/titles.png')" />
      </van-grid-item>
    </van-grid>
    <van-row gutter="10" style="padding:20px 10px">
      <van-col span="12" class="home-btn pay">
        <van-row class="btn-wrapper" @click="skipPage(0)">
          <van-col span="8"><img src="../../assets/Image/pay.png" alt="物业缴费"></van-col>
          <van-col span="16" class="btn-content">
             <van-col span="24" style="font-weight: bold">物业缴费</van-col>
             <!-- <van-col span="24">Payment service</van-col> -->
          </van-col>
        </van-row>
      </van-col>
      <van-col span="12" class="home-btn pay">
        <van-row class="btn-wrapper" @click="skipPage(1)">
          <van-col span="8"><img src="../../assets/Image/center.png" alt="个人中心"></van-col>
          <van-col span="16" class="btn-content">
             <van-col span="24" style="font-weight: bold">个人中心</van-col>
             <!-- <van-col span="24">Personal Center</van-col> -->
          </van-col>
        </van-row>
      </van-col>
      <div style="clear:both"></div>
    </van-row>
    <!-- 该房间下暂无记录 -->
    <van-row>
      <van-col span="24" class="home_content">
        <div class="titel" style="">通知公告</div>
        <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 5%' }"></van-divider>
        <!-- <Authen></Authen> -->
        <div>
            <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                <!-- <van-list v-model:loading="loading" v-model:error="error" error-text="请求失败，点击重新加载" success-text="刷新成功" :finished="finished"  @load="onLoad" > -->
                <van-list v-model:loading="loading" v-model:error="error" error-text="请求失败，点击重新加载" success-text="刷新成功" :finished="finished" >
                    <div v-for="item in list" :key="item" class="noticeCard" @click="openAuth(item)">
                        <van-cell-group :border='false'>
                        <van-cell :value='item.createtime.substring(0,10)' is-link :border='false'>
                            <template #title>
                                <span class="customTile">{{item.title}}</span>
                            </template>
                        </van-cell>
                        </van-cell-group>
                    </div>
                </van-list>
            </van-pull-refresh>
            <van-empty v-if="isShow3"   image="error" description="暂无数据" />
        </div>
      </van-col>
    </van-row>
    <!-- <div style="position:flex;bottom:0"> -->
    <div class="fixedBottom">
      <!-- <van-col span='24' style="font-size:12px;color:gray;text-align:center;margin-bottom:6px">主办单位：三打发大水发生的</van-col> -->
      <van-col span='24' style="font-size:12px;color:gray;text-align:center;padding:15px 0;background-color:#fff">技术支持：山东索福特软件有限公司</van-col>
    </div>

    <!--  -->
  </div>
</template>
<script>
  // import MeetAn from '@/components/MeetAnEmergency/Index.vue'//应急公示的组件
  // import Voting from '@/components/VotingsOwner/Index.vue'//业主表决的组件
  // import Authen from '@/components/AuthenticationSet/Index.vue'//通知公告的组件
  import VueCookie from 'vue-cookie'
  // import wx from 'weixin-js-sdk'
  import { GetQueryString } from '@/assets/js/common.js'
  export default {
    components:{
      // Authen,
      // Voting,
      // MeetAn
    },
    data() {
      return {
        error:false,
        list:[],
        refreshing:false,
        isShow3:false,
        // 
        Privacys:false,
        flowHeight:document.body.offsetHeight,
        houseObj:{},
        showIn:false,
        userName:'',
        checked:false,
        policyList:[],
        userInfo:{},
        // openId: VueCookie.get('openid'),
        // headImgUrl:VueCookie.get('headImgUrl'),
        // nickName:VueCookie.get('nickName'),
        // isRealName:VueCookie.get('isRealName'),
        openId:'',
        headImgUrl:'',
        nickName:'',
        isRealName:0,

        fullName:'',
        // activeName:sessionStorage.getItem('activeName'),
        activeName:'通知公告',
        scanQRCodeValue:'',//扫描结果
        loading: false,
        finished: false,
        quickShow:false,
        screenHeight: document.documentElement.clientHeight,//一个是实施的高度一个是手机整体的高度 底下判断监听
        originHeight: document.documentElement.clientHeight,
        depositType:0,
        contractNo:'',//房屋交易号
        ownerName:'',//业主姓名
        ownerNo:'',//业主身份证号
        imgArr:[],
        // imgArr:[
        //   'https://img01.yzcdn.cn/vant/apple-1.jpg',
        //   'https://img01.yzcdn.cn/vant/apple-2.jpg',
        // ],//轮播图数组
      };
    },
    // beforeRouteLeave(to,from,next){
    //   this.$nextTick(()=>{
    //     if(this.showIn||this.quickShow){
    //       this.showIn = false
    //       this.quickShow = false
    //       next(false)
    //     }else if(!this.showIn||!this.quickShow){
    //       next(true)
    //     }
    //   })
    // },
    beforeRouteLeave(to,from,next){
      this.$nextTick(()=>{
        if(this.showIn||this.quickShow){
            this.showIn = false
            this.quickShow = false
        }
        next()
        // console.log(to,'12345qwert')
      })
    },
    watch:{
      'van-dialog':function(a,b){
        console.log(a)
        console.log(b)
      },
      // 后加的   判断他的路由是不是前进 如果是的话就正常前进  如果是后退退出的话就先关闭弹框后才能后退
      '$route.path':function(newVal,oldVal){
        console.log(newVal)
        console.log(oldVal)
      },
    },
    methods: {
      openAuth(item){
        this.$router.push({
              name:'通知详情',
              params:{
                  content:item.content,
                  createtime:item.createtime,
                  title:item.title,
                  createusername:item.createusername
              }
          })
      },
      onLoad(){
          // console.log('aaaaaaaaaaaaaaaaaaaaaaaaaaaaa')
          let data={
            openId: VueCookie.get('openId'),
            pageNum:1,
            pageSize:1000,
          }
          this.$postQuery('/Notice/getListByOpenId', data)
          .then((response) => {
              // console.log(response)
              if (this.refreshing) {
                  this.list = [];
                  this.refreshing = false;
              }
              if(response.code==200){
                  this.list = response.data.list
                  if(this.list.length==0){
                      this.isShow3 = true
                  }
                  // this.content = response.data.list
                  // 加载状态结束
                  this.loading = false;
                  // // // 数据全部加载完成
                  if (this.list.length >= response.data.list.length) {
                      this.finished = true;
                  }
              }
          }).catch(()=>{
              this.error = true;
              this.loading = false
          })
      },
      onRefresh(){
          // 清空列表数据
        this.finished = false;
        //重新加载数据
        this.loading = true;
        this.onLoad();
      },
      /**
       * 认证
       */
      // Authentication(){
      //   if(this.isRealName==0){
      //     this.$router.push({
      //       path:'/FaceRecognition',
      //     })
      //   }else if(this.isRealName==1){
      //     return
      //   }
        // 
      // },
      /**
       * 点击账单
       */
      OpenUnderstand(){
        this.$router.push({
          path:'/BillingRecords'
        })
        
      },
      // 获取轮播图
      getImg(){
        let data = {
          openId:VueCookie.get('openId')
        }
        this.$postQuery("/AdvertisementInfo/getListByOpenId",data).then((response)=>{
          if(response.code==200){
            
            if(response.data.length>0){
              // this.imgArr = response.data;
              response.data.forEach((item)=>{
                this.imgArr.push('http://www.sdcskj.cn:8082/upload/'+item.advertisementpath)
              })
            }else{
              this.imgArr=[]
            }
            // console.log(this.imgArr);
          }else{
            this.imgArr=[require('../../assets/Image/titles.png')]
          }
          
        })
      },
      // 跳页
      skipPage(query){
        let url = query==0?"/BillingRecords":"/PersonalCenter";
        this.$router.push(url);
        // if(query==1){
        //   this.$router.push('/PersonalCenter')
        // }else if(query==0){
        //   let data={
        //     openid:VueCookie.get('openId')
        //   }
        //   this.$postQuery('/HouseInfo/getBindHouseListByOpenId', data).then((response) => {
        //       if(response.code==200){
        //           if(response.data.length>0){
        //             this.$router.push('/BillingRecords');
        //           }else{
        //             // this.$router.push('/BillingRecords');
        //             this.$dialog.confirm({
        //                 message: '请先绑定房屋后进行交费。',
        //             }).then(() => {
        //                 this.$router.push('/PersonalCenter');
        //             }).catch(()=>{});
        //           }
        //       }
        //   })
        // }
      }
    },
    created(){
      // VueCookie.set('openId','123456')//是否认证存cookie
      
      // this.getAddress()
      // this.getBliInfo()
      // console.log("-----------code--------------");
      let code = GetQueryString("code");
      // console.log(code);
      let data = {
        code: code
      }
      this.$postQuery('/WxUserInfo/getUserInfo',data).then((response)=>{
        this.userInfo = response.data;
        // VueCookie.set('openId',this.userInfo.openid)//存cookie
        // VueCookie.set('headImgUrl',this.userInfo.lheadimgurl)//头像存cookie
        // VueCookie.set('nickName',this.userInfo.nickname)//名字存cookie
        // this.openId = VueCookie.get('openId')
        // this.headImgUrl = VueCookie.get('headImgUrl')
        // this.nickName = VueCookie.get('nickName')
        if(response.data.openid&&response.data.lheadimgurl&&response.data.nickname){
          VueCookie.set('openId',this.userInfo.openid)//存cookie
          VueCookie.set('headImgUrl',this.userInfo.lheadimgurl)//头像存cookie
          VueCookie.set('nickName',this.userInfo.nickname)//名字存cookie
          this.openId = VueCookie.get('openId')
          this.headImgUrl = VueCookie.get('headImgUrl')
          this.nickName = VueCookie.get('nickName')
        }else{
          this.openId = VueCookie.get('openId')
          this.headImgUrl = VueCookie.get('headImgUrl')
          this.nickName = VueCookie.get('nickName')
        }
      }).then(()=>{
        this.onLoad()
        this.getImg();
      })

    }
  }
</script>
<style>
.index_banner .van-grid-item__content{
  padding: 0;
}
.index_banner .van-grid-item{
  z-index: -1;
}
.home-btn .btn-wrapper{
  text-align: center;
  border: 1px solid #ccc;
  border-radius: 3px;
  /* box-shadow:1px 0px 9px 2px #eceaea; */
  padding: 6px 5px;
  cursor: pointer;
}
.home-btn img{
  width: 50px;
  height: 50px;
  display: block;
  margin: 0 auto;
}
.home-btn .btn-content{
  font-size: 16px;
  line-height: 40px;
  padding: 5px 0;
}
.home_content{
  border-radius: 16px;
  background-color:#fff;
  display: block;
}
.head_portrait .van-image{
  position: absolute;
  top: 0;
  left: 0;
}
.home_content .titel{
  text-align:left;
  font-size:14px;
  padding-top:10px;
  font-weight:bold;
  padding-left:5%;
  color:rgb(52, 159, 235);
}
.home_content>.van-image{
  display: block;
  margin: 0 auto;
  padding-top: 60px;
}
.home_content img{
  border-radius: 6px;
}
.iconImgStyle .icon_img{
  padding: 12px;
  border-radius: 50%;
  text-align: center;
  /* border: 1px solid red; */
}
.icon_red{
  background-color:red ;
}
.icon_orange{
  background-color:#ff661a;
}
.icon_blue{
  background-color:#032451;
}
.icon_purple{
  background-color:#761bf3;
}
.icon_green{
  background-color:#09d472;
}
.home_title{
  font-size: 13px;
  margin-top:5px;
  display: block;
}
.info_content .van-row{
  margin:0 10px 20px;
}
.home_tab{
  margin-top: 10px;
}
.customTile{
  display:inline-block;
  width: 150px;
  overflow: hidden; /*超出部分隐藏*/
  text-overflow: ellipsis; /* 超出部分显示省略号 */
  white-space: nowrap; /*规定段落中的文本不进行换行 */
}
.noticeCard{
  margin: 0 10px;
}
.OwnersCard{
  margin:5px 12px;
  box-shadow: 0 8px 12px #ebedf0;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
}
.contentSon{
  padding:0 16px 16px 16px;
}
.contentSon .van-field__body{
  border: 1px solid #e0e0e0;
  padding-left:10px;
}
.contentSon .van-button--primary{
  background-color: transparent;
  border: 0;
  color: black;
  font-size: 16px;
}
.contentSon .van-cell{
  padding: 0;
}
.flexBottom{
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
}
.flexBottom .house_button{
  margin: 10px;
}
.flexBottom  .house_button .van-button,.content_button .van-button{
  padding: 3px 15px;
  width: 100%;
}
.cardBadicus{
  width: 90%;
  margin: 0 auto;
  /* box-shadow: 0 8px 12px #ebedf0; */
  box-shadow: 1px 1px 14px 0px #ebedf0;
  /* 1px 1px 14px 0px #ebedf0 */
  /* padding: 15px 0; */
  margin-top: 8px;
  border-radius: 5px;
  /* border: 1px solid #e0e0e0; */
}
.imgBanner{
  position: relative;
}
.imgBanner .mainBtn{
  position: absolute;
  top:30px;
  left:110px;
  /* display: inline-block; */
}
.userInput .van-field__control{
  padding: 4px 0;
}
.bottom_flex{
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    padding-top: 10px;
    background-color: rgba(255, 255,255, 0.9);
}
.secondFlex{
    padding: 0 10px;
}
.sizeOwerflow{
    font-size: 13px;
    /* line-height: 18px; */
    display: flex !important;
    align-items: center;
}
.flexed{
  margin: 10px;
  
}
.secondFlexs{
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  /* color: rgb(247, 198, 109); */
}
.van-swipe img{
  width: 100%;
  display: block;
  height: 200px;
}
.fixedBottom{
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}
/* padding: 16px 16px 160px; */
</style>